export const createUnassignedMarker = (stop, color) => {
  const svg = `
        <svg width="38" height="38" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="4" width="32" height="32" rx="16" fill="${
            color || "#202124"
          }" fill-opacity="0.2"/>
          
          <g filter="url(#filter0_dd)">
            <rect x="12" y="12" width="16" height="16" rx="8" fill="${
              color || "#5F6368"
            }"/>
            <rect x="13" y="13" width="14" height="14" rx="7" stroke="white" stroke-width="2"/>
          </g>
          
          <defs>
            <filter id="filter0_dd" x="0" y="4" width="400" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset/>
              
              <feGaussianBlur stdDeviation="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              
              <feGaussianBlur stdDeviation="4"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
            </filter>
          </defs>
        </svg>`;

  return `<img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
    svg
  )}" />
          <p class="address">
           ${(stop.information && stop.information.street) || ""}
        </p>`;
};

export const createStopMarker = (stop, index, color, status) => {
  const finished = status === "finished";
  const skipped = status === "skipped";
  const svg = `
        <svg width="52" height="76" viewBox="0 0 26 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(0, 1)">
            <rect x="8" y="37" width="10" height="10" rx="5" fill="${
              color || "#202124"
            }" fill-opacity="0.16"/>
            
            <g filter="url(#filter0_dd)">
              <rect x="9" y="38" width="8" height="8" rx="4" fill="${
                color || "#5F6368"
              }"/>
              <rect x="9.5" y="38.5" width="7" height="7" rx="3.5" stroke="white"/>
            </g>
            
            <mask id="path-4-inside-1" fill="white">
              <path d="M13 0C5.81286 0 0 5.81286 0 13C0 20.7443 8.20857 31.4229 11.5886 35.49C12.3314 36.3814 13.6871 36.3814 14.43 35.49C17.7914 31.4229 26 20.7443 26 13C26 5.81286 20.1871 0 13 0Z"/>
            </mask>
            
            <path stroke-width="1.5" stroke="white" d="M13 0C5.81286 0 0 5.81286 0 13C0 20.7443 8.20857 31.4229 11.5886 35.49C12.3314 36.3814 13.6871 36.3814 14.43 35.49C17.7914 31.4229 26 20.7443 26 13C26 5.81286 20.1871 0 13 0Z" fill="${
              color || "#5F6368"
            }"/>
            <path d="M13 23C7.48 23 3 18.52 3 13C3 7.48 7.48 3 13 3C18.52 3 23 7.48 23 13C23 18.52 18.52 23 13 23Z" fill="${
              finished ? color : "white"
            }" ${finished ? 'stroke="white" stroke-width="1.5"' : ""} />
          </g>

          <defs>
            <filter id="filter0_dd" x="1" y="34" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset/>
              
              <feGaussianBlur stdDeviation="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="0"/>
              
              <feGaussianBlur stdDeviation="4"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
            </filter>
          </defs>
        </svg>`;

  return `<img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
    svg
  )}" />
          <span class="index ${finished ? "index-white" : ""}" ${
    skipped ? `style="font-size: 18px;"` : ""
  }>
            ${skipped ? "&times;" : index}
          </span>
          <p class="address">
            ${(stop.information && stop.information.street) || ""}
          </p>`;
};

export const createEditMarker = (stop, index, color, fill) => {
  const svg = `
        <svg width="36" height="66" viewBox="0 0 36 66" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="13" y="45" width="10" height="10" rx="5" fill="${
            color || "#202124"
          }" fill-opacity="0.16"/>
          
          <g filter="url(#filter0_dd)">
            <rect x="14" y="46" width="8" height="8" rx="4" fill="${
              color || "#5F6368"
            }"/>
            <rect x="14.5" y="46.5" width="7" height="7" rx="3.5" stroke="white"/>
          </g>
          
          <g filter="url(#filter1_d)">
            <mask id="path-4-inside-1" fill="white">
              <path d="M18 2C9.70714 2 3 8.70714 3 17C3 25.9357 12.4714 38.2571 16.3714 42.95C17.2286 43.9786 18.7929 43.9786 19.65 42.95C23.5286 38.2571 33 25.9357 33 17C33 8.70714 26.2929 2 18 2Z"/>
            </mask>
            
            <path d="M18 2C9.70714 2 3 8.70714 3 17C3 25.9357 12.4714 38.2571 16.3714 42.95C17.2286 43.9786 18.7929 43.9786 19.65 42.95C23.5286 38.2571 33 25.9357 33 17C33 8.70714 26.2929 2 18 2Z" fill="white"/>
            <path d="M16.3714 42.95L14.8333 44.2283L14.835 44.2304L16.3714 42.95ZM19.65 42.95L21.1865 44.2304L21.1916 44.2241L19.65 42.95ZM18 0C8.60257 0 1 7.60257 1 17H5C5 9.81171 10.8117 4 18 4V0ZM1 17C1 22.0472 3.62451 27.7636 6.50586 32.5911C9.43609 37.5005 12.8513 41.8435 14.8333 44.2283L17.9096 41.6717C15.9915 39.3637 12.7211 35.1995 9.94057 30.541C7.1112 25.8007 5 20.8885 5 17H1ZM14.835 44.2304C16.4917 46.2184 19.5297 46.2184 21.1864 44.2304L18.1136 41.6696C18.0931 41.6941 18.0761 41.7046 18.0635 41.7104C18.0487 41.7171 18.0307 41.7214 18.0107 41.7214C17.9907 41.7214 17.9727 41.7171 17.9579 41.7104C17.9453 41.7046 17.9283 41.6941 17.9079 41.6696L14.835 44.2304ZM21.1916 44.2241C23.1605 41.8419 26.57 37.4994 29.4972 32.5904C32.3756 27.7634 35 22.047 35 17H31C31 20.8887 28.8887 25.8008 26.0617 30.5417C23.2836 35.2006 20.0181 39.3653 18.1084 41.6759L21.1916 44.2241ZM35 17C35 7.60257 27.3974 0 18 0V4C25.1883 4 31 9.81171 31 17H35Z" fill="${
              color || "#5F6368"
            }" mask="url(#path-4-inside-1)"/>
          </g>
          
          <defs>
            <filter id="filter0_dd" x="6" y="42" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset/>
              
              <feGaussianBlur stdDeviation="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              
              <feGaussianBlur stdDeviation="4"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
            </filter>
            
            <filter id="filter1_d" x="0" y="0" width="36" height="47.7214" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="1"/>
              
              <feGaussianBlur stdDeviation="1.5"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
          </defs>
        </svg>`;

  return `
       <img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
         svg
       )}" />
        
       <span class="index">
         ${index}
       </span>
        
       <p class="address">
          ${(stop.information && stop.information.street) || ""}
       </p>`;
};

export const createStartEndMarker = (stop, color, end) => {
  const svg = `
        <svg width="35" height="60" viewBox="0 0 32 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(4, 1)">
            <rect x="7" y="31" width="10" height="10" rx="5" fill="${
              color || "#202124"
            }" fill-opacity="0.16"/>
            
            <g filter="url(#filter0_dd)">
              <rect x="8" y="32" width="8" height="8" rx="4" fill="${
                color || "#5F6368"
              }"/>
              <rect x="8.5" y="32.5" width="7" height="7" rx="3.5" stroke="white"/>
            </g>
            
            <path stroke="white" stroke-width="1.5" d="M12 0C5.91857 0 1 4.91857 1 11C1 17.5529 7.94571 26.5886 10.8057 30.03C11.4343 30.7843 12.5814 30.7843 13.21 30.03C16.0543 26.5886 23 17.5529 23 11C23 4.91857 18.0814 0 12 0Z" fill="${
              color || "#5F6368"
            }"/>
            
            ${
              end
                ? `
            <path transform="translate(0.8,0)" d="M13.2667 8.33333L13.1067 7.53333C13.0467 7.22667 12.7733 7 12.4533 7H7.66667C7.3 7 7 7.3 7 7.66667V17.6667C7 18.0333 7.3 18.3333 7.66667 18.3333C8.03333 18.3333 8.33333 18.0333 8.33333 17.6667V13.6667H12.0667L12.2267 14.4667C12.2867 14.78 12.56 15 12.88 15H16.3333C16.7 15 17 14.7 17 14.3333V9C17 8.63333 16.7 8.33333 16.3333 8.33333H13.2667Z" fill="white"/>
            `
                : `
            <path transform="translate(1.2,0)" d="M9.69421 16.2097V12.9489H12.3029V16.2097C12.3029 16.5684 12.5964 16.8619 12.9551 16.8619H14.9116C15.2703 16.8619 15.5637 16.5684 15.5637 16.2097V11.6445H16.6724C16.9724 11.6445 17.1159 11.2728 16.8876 11.0771L11.4355 6.1663C11.1877 5.94457 10.8094 5.94457 10.5616 6.1663L5.10947 11.0771C4.88773 11.2728 5.02469 11.6445 5.32468 11.6445H6.43337V16.2097C6.43337 16.5684 6.72685 16.8619 7.08554 16.8619H9.04205C9.40074 16.8619 9.69421 16.5684 9.69421 16.2097Z" fill="white"/>
            `
            }
          </g>
          
          <mask id="path-4-inside-1" fill="white">
            <path d="M12 0C5.91857 0 1 4.91857 1 11C1 17.5529 7.94571 26.5886 10.8057 30.03C11.4343 30.7843 12.5814 30.7843 13.21 30.03C16.0543 26.5886 23 17.5529 23 11C23 4.91857 18.0814 0 12 0Z"/>
          </mask>
          
          <defs>
            <filter id="filter0_dd" x="0" y="28" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset/>
              <feGaussianBlur stdDeviation="1"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="4"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
            </filter>
          </defs>
        </svg>`;

  return `
          <img style="pointer-events: none;" src="data:image/svg+xml;base64,${btoa(
            svg
          )}" />
        
          <p class="address">
            ${(stop.information && stop.information.street) || ""}
          </p>`;
};

export const createDriverMarker = color => {
  return `
        <svg width="40" height="56" viewBox="0 0 40 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 56C17.79 56 16 54.21 16 52C16 49.79 17.79 48 20 48C22.21 48 24 49.79 24 52C24 54.21 22.21 56 20 56Z" fill="${
            color || "#5F6368"
          }"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9997 54C20.266 54.006 20.5309 53.9588 20.7787 53.861C21.0266 53.7633 21.2524 53.617 21.4429 53.4308C21.6334 53.2446 21.7848 53.0222 21.8882 52.7766C21.9916 52.5311 22.0449 52.2674 22.0449 52.001C22.045 51.7346 21.9918 51.4708 21.8886 51.2253C21.7853 50.9797 21.634 50.7572 21.4436 50.5709C21.2532 50.3846 21.0274 50.2382 20.7797 50.1403C20.5319 50.0425 20.267 49.9951 20.0007 50.001C19.4781 50.0125 18.9809 50.2282 18.6153 50.6018C18.2498 50.9754 18.0451 51.4773 18.0449 52C18.0448 52.5227 18.2493 53.0246 18.6146 53.3984C18.98 53.7722 19.4772 53.9882 19.9997 54Z" fill="white"/>
          <path d="M20.4435 44.8026C20.4383 44.9144 20.3903 45.0199 20.3093 45.0972C20.2283 45.1745 20.1206 45.2175 20.0087 45.2174C19.7565 45.2174 19.5652 45.0348 19.5565 44.8026C19.4304 42.0478 18.0296 40.2661 15.3548 39.4574C6.54783 37.3635 0 29.4461 0 20C0 8.95391 8.95391 0 20 0C31.0461 0 40 8.95391 40 20C40 29.4461 33.4522 37.3635 24.6452 39.4574C21.9704 40.2661 20.5696 42.0487 20.4452 44.8026H20.4435Z" fill="${
            color || "#5F6368"
          }"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M25 16H28L31 20V25H29C29 26.66 27.66 28 26 28C24.34 28 23 26.66 23 25H17C17 26.66 15.66 28 14 28C12.34 28 11 26.66 11 25H9V14C9 12.9 9.9 12 11 12H25V16ZM13 25C13 25.55 13.45 26 14 26C14.55 26 15 25.55 15 25C15 24.45 14.55 24 14 24C13.45 24 13 24.45 13 25ZM27.5 17.5L29.46 20H25V17.5H27.5ZM25 25C25 25.55 25.45 26 26 26C26.55 26 27 25.55 27 25C27 24.45 26.55 24 26 24C25.45 24 25 24.45 25 25Z" fill="white"/>
        </svg>`;
};

export const createPinpointMarker = () => {
  return `
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path transform="scale(0.8), translate(4, 4)" fill-rule="evenodd" clip-rule="evenodd" d="M24.0002 10.668C24.0002 6.25464 20.4135 2.66797 16.0002 2.66797C11.5868 2.66797 8.00016 6.25464 8.00016 10.668C8.00016 16.668 16.0002 25.3346 16.0002 25.3346C16.0002 25.3346 24.0002 16.668 24.0002 10.668ZM13.3338 10.6673C13.3338 9.20065 14.5338 8.00065 16.0005 8.00065C17.4672 8.00065 18.6672 9.20065 18.6672 10.6673C18.6672 12.134 17.4805 13.334 16.0005 13.334C14.5338 13.334 13.3338 12.134 13.3338 10.6673ZM6.66699 29.3346V26.668H25.3337V29.3346H6.66699Z" fill="#202124"/>
        </svg>`;
};
